exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._10rbIZXqvyPcYQuX3WSyeC{padding:0 20px;margin:10px 0 15px 0}._10rbIZXqvyPcYQuX3WSyeC button{color:\"[theme:themeDarkAlt, default:#005A9E]\"}._3hvvWSiXysl7jyyJUFTKhS{height:auto!important}html[dir] ._3hvvWSiXysl7jyyJUFTKhS{margin:0!important}", ""]);
// Exports
exports.locals = {
	"feedbackContainer": "_10rbIZXqvyPcYQuX3WSyeC",
	"ribbonMessage": "_3hvvWSiXysl7jyyJUFTKhS"
};